const _ = require('lodash');

const BODY_OVERLAY_CLASS = '__with-overlay';
const body = document.querySelector('body');
const overlay = document.getElementById('body-overlay');
const cList = overlay.classList;
export const bodyClass = body.classList;

const defaultOpts = {
  hideOnClick: true,
  onShow: null,
  onHide: null,
};

let options = {};

// eslint-disable-next-line require-jsdoc
export function pageOverlayShow(opts) {
  const options = _.merge(defaultOpts, opts);

  if (overlay) {
    // Add listener
    const onShowHandler = () => {
      if (typeof options.onShow === 'function') {
        options.onShow();
      }

      overlay.removeEventListener('transitionend', onShowHandler);
    };

    overlay.addEventListener('transitionend', onShowHandler);

    bodyClass.add(BODY_OVERLAY_CLASS);
    cList.add('visible');
    cList.add('show');

    if (options.hideOnClick) {
      overlay.addEventListener('click', pageOverlayHide);
    }
  }
}

// eslint-disable-next-line require-jsdoc
export function pageOverlayHide(opts) {
  options = _.merge(defaultOpts, opts);

  if (overlay) {
    if (cList.contains('visible')) {
      const onHideHandler = () => {
        cList.remove('visible');
        bodyClass.remove(BODY_OVERLAY_CLASS);

        overlay.removeEventListener('transitionend', onHideHandler);
      };

      overlay.addEventListener('transitionend', onHideHandler);

      if (typeof options.onHide === 'function') {
        options.onHide();
      }

      overlay.classList.remove('show');
    }
  }
}
